const COLUMN_LAYOUT_PREFIX = 'tt-column-layout';

const sanitizePathname = (pathname) => {
  if (!pathname || pathname === '/') {
    return 'root';
  }

  return pathname.replace(/^\//, '').replace(/\//g, ':');
};

const getStorageKey = (scope = 'overview') =>
  `${COLUMN_LAYOUT_PREFIX}:${sanitizePathname(window.location.pathname)}:${scope}`;

const parseStoredState = (value) => {
  if (!value) {
    return null;
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

const getColumnId = (columnDef) => columnDef?.colId || columnDef?.field || null;

export const getColumnLayoutScope = (tenderId) =>
  tenderId ? `tender-${tenderId}` : 'overview';

export const hasSavedColumnLayout = (scope = 'overview') =>
  Boolean(parseStoredState(localStorage.getItem(getStorageKey(scope))));

export const saveGridColumnLayout = (columnApi, scope = 'overview') => {
  if (!columnApi?.getColumnState) {
    return;
  }

  const columnState = columnApi.getColumnState();

  if (!Array.isArray(columnState) || columnState.length === 0) {
    return;
  }

  localStorage.setItem(getStorageKey(scope), JSON.stringify(columnState));
};

export const applySavedColumnLayout = (columnDefs, scope = 'overview') => {
  if (!Array.isArray(columnDefs) || columnDefs.length === 0) {
    return columnDefs;
  }

  const savedState = parseStoredState(localStorage.getItem(getStorageKey(scope)));

  if (!savedState) {
    return columnDefs;
  }

  const stateById = new Map();

  savedState.forEach((state, index) => {
    const columnId = state?.colId || state?.field;

    if (!columnId) {
      return;
    }

    stateById.set(columnId, { state, index });
  });

  return columnDefs
    .map((columnDef, originalIndex) => {
      const columnId = getColumnId(columnDef);
      const savedEntry = columnId ? stateById.get(columnId) : null;
      const nextColumnDef = { ...columnDef };

      if (savedEntry?.state) {
        const { state } = savedEntry;

        if (state.hide !== undefined) {
          nextColumnDef.hide = state.hide;
        }

        if (state.pinned !== undefined) {
          nextColumnDef.pinned = state.pinned || undefined;
        }

        if (typeof state.width === 'number' && Number.isFinite(state.width)) {
          nextColumnDef.width = state.width;
        }

        if (typeof state.flex === 'number' && Number.isFinite(state.flex)) {
          nextColumnDef.flex = state.flex;
        }
      }

      return {
        columnDef: nextColumnDef,
        sortIndex: savedEntry ? savedEntry.index : savedState.length + originalIndex,
      };
    })
    .sort((left, right) => left.sortIndex - right.sortIndex)
    .map(({ columnDef }) => columnDef);
};